<template>
  <header class="header">
    <div class="inner">
      <div class="logo">
        <router-link to="/" class="link-over">
          <img src="../assets/img/logo-img.svg" alt="CDP Logo" />
        </router-link>
      </div>
      <div class="detail">
        <p>
          <span class="txt">{{ $t("BALANCE") }}</span>
          <span class="number"> <b>100</b>USD </span>
        </p>
      </div>
      <div class="menu link-over" v-on:click="toggleMenu">
        <span class="line line1"></span>
        <span class="line line2"></span>
        <span class="line line3"></span>
      </div>
    </div>
    <div class="ani-txt-bar" style="display: none">
      <p>
        ALEPHZERO DIFFUSION PROJECT ALEPHZERO DIFFUSION PROJECT ALEPHZERO
        DIFFUSION PROJECT ALEPHZERO DIFFUSION PROJECT ALEPHZERO DIFFUSION
        PROJECT ALEPHZERO DIFFUSION PROJECT ALEPHZERO DIFFUSION PROJECT
        ALEPHZERO DIFFUSION PROJECT ALEPHZERO DIFFUSION PROJECT ALEPHZERO
        DIFFUSION PROJECT ALEPHZERO DIFFUSION PROJECT ALEPHZERO DIFFUSION
        PROJECT ALEPHZERO DIFFUSION PROJECT ALEPHZERO DIFFUSION PROJECT
        ALEPHZERO DIFFUSION PROJECT ALEPHZERO DIFFUSION PROJECT ALEPHZERO
        DIFFUSION PROJECT ALEPHZERO DIFFUSION PROJECT ALEPHZERO DIFFUSION
        PROJECT ALEPHZERO DIFFUSION PROJECT ALEPHZERO DIFFUSION PROJECT
        ALEPHZERO DIFFUSION PROJECT ALEPHZERO DIFFUSION PROJECT ALEPHZERO
        DIFFUSION PROJECT
      </p>
    </div>
    <div
      class="hidden-menu"
      v-bind:class="{
        active: active,
      }"
    >
      <!-- Hidden menu -->
      <div class="hidden-background"></div>
      <div class="hidden-inner">
        <div class="ttl">
          {{ $t("MENU") }}
          <div class="close-box link-over" v-on:click="toggleMenu">
            <span class="line line1"></span>
            <span class="line line2"></span>
          </div>
        </div>
        <div class="y-scroll">
          <ul class="hidden-menu-list">
            <li>
              <router-link to="/" class="link-over">
                <div class="img">
                  <img src="../assets/img/header-menu-icon1-img.png" alt="" />
                </div>
                <p>{{ $t("My Wallet") }}</p>
              </router-link>
            </li>
            <li>
              <router-link to="./deposit" class="link-over">
                <div class="img">
                  <img src="../assets/img/header-menu-icon2-img.png" alt="" />
                </div>
                <p>{{ $t("CHARGE") }}</p>
              </router-link>
            </li>
            <li>
              <router-link to="./plan" class="link-over">
                <div class="img">
                  <img src="../assets/img/header-menu-icon3-img.png" alt="" />
                </div>
                <p>{{ $t("PLAN") }}</p>
              </router-link>
            </li>
            <li>
              <router-link to="./history" class="link-over">
                <div class="img">
                  <img src="../assets/img/header-menu-icon4-img.png" alt="" />
                </div>
                <p>{{ $t("HISTORY") }}</p>
              </router-link>
            </li>
            <li>
              <router-link to="./organizationchart" class="link-over">
                <div class="img">
                  <img src="../assets/img/header-menu-icon5-img.png" alt="" />
                </div>
                <p>{{ $t("Organization") }}</p>
              </router-link>
            </li>
            <li>
              <router-link to="./withdraw" class="link-over">
                <div class="img">
                  <img src="../assets/img/header-menu-icon6-img.png" alt="" />
                </div>
                <p>{{ $t("WITHDRAW") }}</p>
              </router-link>
            </li>
            <li>
              <router-link to="./transfer" class="link-over">
                <div class="img">
                  <img src="../assets/img/header-menu-icon7-img.png" alt="" />
                </div>
                <p>{{ $t("Transfer and exchange") }}</p>
              </router-link>
            </li>
            <li>
              <router-link to="./account" class="link-over">
                <div class="img">
                  <img src="../assets/img/header-menu-icon8-img.png" alt="" />
                </div>
                <p>{{ $t("ACCOUNT") }}</p>
              </router-link>
            </li>
            <li>
              <router-link to="./referral" class="link-over">
                <div class="img">
                  <img src="../assets/img/header-menu-icon9-img.png" alt="" />
                </div>
                <p>{{ $t("REFERRAL CODE") }}</p>
              </router-link>
            </li>
            <li>
              <router-link to="./newslist" class="link-over">
                <div class="img">
                  <img src="../assets/img/header-menu-icon10-img.png" alt="" />
                </div>
                <p>{{ $t("NEWS") }}</p>
              </router-link>
            </li>
            <li>
              <router-link to="./salesManagement" class="link-over">
                <div class="img">
                  <img src="../assets/img/header-menu-icon11-img.png" alt="" />
                </div>
                <p>{{ $t("SALES MANAGEMENT") }}</p>
              </router-link>
            </li>
            <li>
              <router-link to="./faq" class="link-over">
                <div class="img">
                  <img src="../assets/img/header-menu-icon13-img.png" alt="" />
                </div>
                <p>{{ $t("FAQ") }}</p>
              </router-link>
            </li>
            <li>
              <router-link to="./contact" class="link-over">
                <div class="img">
                  <img src="../assets/img/header-menu-icon12-img.png" alt="" />
                </div>
                <p>{{ $t("CONTACT") }}</p>
              </router-link>
            </li>
          </ul>
        </div>
        <div class="logout-txt">
          <span class="link-over" v-on:click="showLogout">{{
            $t("SIGN OUT")
          }}</span>
        </div>
      </div>
    </div>
    <modal
      name="logoutModal"
      :resizable="true"
      :adaptive="true"
      :scrollable="true"
      width="90%"
      height="auto"
    >
      <div class="modal-box logout-box">
        <div class="modal-ttl">
          <p>
            {{ $t("Are you sure you want to log out?") }}
          </p>
        </div>
        <div class="btn">
          <button v-on:click="hideLogout" type="button" class="link-over">
            {{ $t("SIGN OUT") }}
          </button>
        </div>
      </div>
    </modal>
  </header>
</template>

<script>
export default {
  name: "Header",
  props: {},
  data() {
    return {
      active: false,
    };
  },
  methods: {
    toggleMenu() {
      this.active = !this.active;
    },
    showLogout: function () {
      this.$modal.show("logoutModal");
    },
    hideLogout: function () {
      this.$modal.hide("logoutModal");
    },
  },
  mounted: function () {},
};
</script>

<style scoped lang="less"></style>
